import Theme from '../../styles/Theme/Theme';
import { Text } from "../Global/Atomics/Text";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import SemiCircle from "../Global/Charts/semiCircle";
import CustomIcon from "../Global/Icons/CustomIcon";

export const SemiCircleWidget = (props) => {
  return (
    <WidgetCard
      display="flex"
      flexDirection="column"
      padding={Theme.spacing.videowall.md}
      margin={Theme.spacing.videowall.xxs}
      justifyContent="space-between">
      <div style={{ display: "flex", alignItems: 'center', }}>
        <CustomIcon icon={"Gear"} color={Theme.color['teal-4']} iconSize='md' />
        <Text color="black" marginLeft="0.4vw" fontSize="text_lg" fontWeight={Theme.typography.weight.medium}>
          {props?.block?.title}
        </Text>
      </div>
      <div style={{ display: "flex", position: "relative", width: "100%", height: "100%", alignItems: "center" }}>
        <div style={{ position: "absolute", display: "flex", alignItems: "center", justifyContent: 'center', top: 0, left: 0, right: 0, bottom: 0 }}>
          <SemiCircle data={props?.block?.value ?? 0} />
        </div>
      </div>
    </WidgetCard>
  )
}